import { useState } from "react";
import { Beer, BeerFlight } from "../../../data/types";
import "./FlightForm.scss";
import CustomDropdown from "../../CustomDropDown/CustomDropDown";

interface FlightFormProps {
  beers: Beer[];
  onSubmit: (flight: BeerFlight) => void;
}

const FlightForm: React.FC<FlightFormProps> = ({ beers, onSubmit }) => {
  const [selectedBeers, setSelectedBeers] = useState<(Beer | null)[]>(
    Array(5).fill(null)
  );
  const [flightTitle, setFlightTitle] = useState<string>("");
  const [flightDescription, setFlightDescription] = useState<string>("");

  const handleChange = (index: number, beer: Beer) => {
    const updated = [...selectedBeers];
    updated[index] = beer;
    setSelectedBeers(updated);
  };

  const handleReset = () => {
    const empty = Array(5).fill(null);
    setSelectedBeers(empty);

    const flight: BeerFlight = {
      beers: empty,
      name: "", // eller lägg till inputfält för namn
      description: "", // eller lägg till inputfält
    };

    onSubmit(flight);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const flight: BeerFlight = {
      beers: selectedBeers,
      name: flightTitle,
      description: flightDescription,
    };

    onSubmit(flight);
  };

  return (
    <form className="flight-form" onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Title (optional)"
        onChange={(e) => setFlightTitle(e.target.value)}
      />
      <textarea
        placeholder="Description (optional)"
        onChange={(e) => setFlightDescription(e.target.value)}
      />

      {selectedBeers.map((beer, index) => (
        <div key={index} className="flight-form__select">
          <CustomDropdown
            number={index + 1}
            options={beers}
            selected={beer}
            onChange={(selectedBeer) => handleChange(index, selectedBeer)}
          />
        </div>
      ))}

      <div className="flight-form__buttons">
        <button className="flight-form__buttons--save" type="submit">
          Save
        </button>
        <button
          className="flight-form__buttons--reset"
          type="button"
          onClick={handleReset}
        >
          Reset
        </button>
      </div>
    </form>
  );
};

export default FlightForm;
